import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import GamePage from "./pages/GamePage";
import Leaderboard from "./pages/Leaderboard";
import Shop from "./pages/Shop";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import TrackOrder from "./pages/TrackOrder";
import AccountPage from "./pages/AccountPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./components/AuthCallback";
import AnalyticsTracker from "./components/AnalyticsTracker";
import AnnouncementBar from "./components/AnnouncementBar";
import { Toaster } from "./components/ui/toaster";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import CartDrawer from "./components/CartDrawer";

// Detects session_id in URL hash and mounts AuthCallback instead of normal routes
const AppRouter = () => {
  const location = useLocation();

  // Force browser tab title to TruCrunch (Emergent script would otherwise override it)
  useEffect(() => {
    const setTitle = () => { document.title = 'TruCrunch'; };
    setTitle();
    const t = setInterval(setTitle, 1000); // guard against late overrides
    return () => clearInterval(t);
  }, []);

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/play" element={<GamePage />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/order/:id" element={<OrderSuccess />} />
      <Route path="/track" element={<TrackOrder />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <AnnouncementBar />
            <AnalyticsTracker />
            <AppRouter />
            <CartDrawer />
            <Toaster />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
